import { HttpHeaders } from '@angular/common/http';
import { UserService } from '../core/user/user.service';
import {DateTime} from "luxon";

export default class Utils {
    static isNewObject(object) {
      if (Object.keys(object).length == 0){
        return true;
      }
      return false;
    }

    static getIdTokenExpirationDateTime():DateTime{
      let idTokenExpirationOffsetMinutes = 50;
      let idTokenExpirationDateTime = DateTime.now().plus({'minutes':idTokenExpirationOffsetMinutes})
      return idTokenExpirationDateTime
    }

    static getAuthenticationHeaders(userService: UserService){
      let token;
      userService.refreshTokenIfNeeded()
      userService.user$.subscribe((user) => {
        token = user.token;
      });
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': "Bearer " + token
        })
      };
      return httpOptions
    }

    static getIndexedWorkers(timesheets){
      let indexes = [];
      timesheets.forEach(timesheet => {
        indexes.push(timesheet.employee.id);
      })
      return indexes
    }
}